import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueTippy, { TippyComponent } from "vue-tippy";

import vClickOutside from 'v-click-outside'

import VueAnalytics from 'vue-analytics'


import 'materialize-css/dist/css/materialize.min.css'
import '@/assets/sass/app.scss'
import json from './_results.json'


Vue.config.productionTip = false

Vue.prototype.globalData = json;


Vue.use(vClickOutside);
Vue.use(VueTippy);
// Vue.use(VueAnalytics, {
//     id: 'UA-74419788-1'
// });
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
